<template>
  <div>
    <div class="modal-backdrop"></div>
    <div class="modal">
      <div class="content">
        <div class="pull-right database-modal">
          <div class="btn-close" @click="close"></div>
        </div>
        <h1>Datenbank Auswählen</h1>

        <div class="database-drop-dwon">
          <!-- <div class="tab">
            <h3>Operation</h3>
            <div class="input-group">
              <GeneralDropdown className="select-operation">
                <template v-slot:selectFilter>
                  <span> {{ selectedOperation.text }}</span>
                </template>
                <template v-slot:optionData>
                  <b-dropdown-item
                    v-for="(option, index) in options"
                    :key="index"
                    @click="onSelectOperation(option)"
                  >
                    {{ option.text }}
                  </b-dropdown-item>
                </template>
              </GeneralDropdown>
            </div>
          </div> -->
          <div class="tab">
            <h3>Datenbank</h3>
            <div class="input-group">
              <GeneralDropdown className="select-operation">
                <template v-slot:selectFilter>
                  <span> {{ selectedDatabaseCaption }}</span>
                </template>
                <template v-slot:optionData>
                  <b-dropdown-item
                    v-for="database in filterDataBase"
                    :key="database.name"
                    @click="onDatabaseSelect(database)"
                  >
                    {{ database.caption }}
                  </b-dropdown-item>
                </template>
              </GeneralDropdown>
            </div>
          </div>
        </div>
        <div class="tab" v-if="selectedDatabaseSchema">
          <!-- :operationType="selectedOperation.value" -->
          <ObjectMapper
            ref="objectMapperRef"
            :task="task"
            :databaseSchema="selectedDatabaseSchema"
            :defaultItems="getObjectMappingDefaultItems"
          ></ObjectMapper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../store/store';
import ObjectMapper from '../widgets/object-mapper.vue';
import { getUserDatabases } from '../../services/userTable';
import GeneralDropdown from '../core/general-dropdown.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Database',
  data() {
    return {
      userTables: [],
      options: [
        { value: 'read', text: 'Lesen' },
        { value: 'write', text: 'Erstellen' },
        { value: 'edit', text: 'Bearbeiten' },
        { value: 'delete', text: 'Loschen' },
      ],
      // selectedOperation: { value: null, text: null },
      selectedDatabaseName: null,
      selectedDatabaseSchema: null,
      selectedDatabaseCaption: null,
    };
  },
  props: {
    task: Object,
  },
  methods: {
    close: function () {
      // this.task.props.operation = this.selectedOperation.value;
      this.task.props.database = this.selectedDatabaseName;
      this.task.props.item = this?.$refs.objectMapperRef?.getOutputJson;
      this.$emit('close');
    },
    onDatabaseSelect(database) {
      const selectedDatabase = this.userTables.find(
        (userTable) => userTable.name.trim() === database.name.trim()
      );

      if (selectedDatabase) {
        this.selectedDatabaseSchema = selectedDatabase.schema;
        this.selectedDatabaseName = selectedDatabase.name;
        this.selectedDatabaseCaption = selectedDatabase.caption;
      }
    },
    // onSelectOperation(option) {
    //   this.selectedOperation = option;
    //   this.selectedDatabaseName = null;
    //   this.selectedDatabaseSchema = null;
    // },
  },
  computed: {
    ...mapGetters({ databaseList: 'getDatabaseList' }),
    user() {
      return store.state.user;
    },
    filterDataBase() {
      // if (this.selectedOperation.value === 'read')
      //   return this.userTables.filter((userTable) =>
      //     ['read'].includes(userTable.access_level)
      //   );
      // if (this.selectedOperation.value === 'write')
      //   return this.userTables.filter((userTable) =>
      //     ['full_access', 'write', 'owner'].includes(userTable.access_level)
      //   );
      // if (this.selectedOperation.value === 'edit')
      //   return this.userTables.filter(
      //     (userTable) =>
      //       ['full_access', 'write', 'owner'].includes(
      //         userTable.access_level
      //       ) && !userTable.hasOwnProperty('add_only')
      //   );
      // if (this.selectedOperation.value === 'delete')
      //   return this.userTables.filter(
      //     (userTable) =>
      //       ['full_access', 'write', 'owner'].includes(
      //         userTable.access_level
      //       ) && !userTable.hasOwnProperty('add_only')
      //   );
      // if (this.userTables.length)
      //   return this.userTables.filter(
      //     (userTable) => !['read'].includes(userTable.access_level)
      //   );
      // return [];

      if (this.userTables.length) {
        if (this.task.props.database) {
          return this.userTables.filter(
            (el) => el.name.trim() !== this.task.props.database.trim()
          );
        } else {
          return this.userTables;
        }
      }

      return [];
    },
    getObjectMappingDefaultItems() {
      if (this.selectedDatabaseName == this.task.props.database)
        return this.task.props.item;
      return {};
    },
  },
  async created() {
    let customTables;
    if (this.databaseList.length) {
      customTables = this.databaseList;
    } else {
      customTables = await getUserDatabases();
    }
    this.userTables = customTables.filter(
      (database) =>
        database.type === 'custom' && !['read'].includes(database.access_level)
    );

    if (this.task.props.database) {
      // this.selectedOperation.value = this.task.props.operation;
      // this.selectedOperation.text = this.options.find(
      //   (option) => option.value === this.selectedOperation.value
      // ).text;
      // this.selectedDatabaseName = this.task.props.database;
      this.onDatabaseSelect({ name: this.task.props.database });
    }
  },
  components: {
    ObjectMapper,
    GeneralDropdown,
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  box-shadow: 0 1px 10px rgb(0 0 0 / 15%), 0 2.4px 5.7px rgb(0 0 0 / 2%),
    0 4px 11.3px rgb(0 0 0 / 2%), 0 10.6px 17.5px rgb(0 0 0 / 2%),
    0 14px 25.7px rgb(0 0 0 / 3%), 0 35.5px 39.6px rgb(0 0 0 / 4%),
    0 40px 48px rgb(0 0 0 / 3%);
  display: block;
  position: fixed;
  width: 1000px;
  left: 0;
  right: 0;
  margin-right: auto;
  margin-left: auto;
  height: 98%;
  top: 1%;
  text-align: left;
  -webkit-font-smoothing: antialiased;
  border: solid 0.05px #c3c4c6;
  border-radius: 13px;
  padding-top: 35px;
}

.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  height: 100%;
}

h1 {
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

h3 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

.tab {
  text-align: left;
  /* border-top: 1px solid #eaecf1;
  background: #f9f9fb; */
  padding: 20px 30px;
  min-height: 150px;
  width: 100%;
  height: calc(100% - (163px + 90px));
}

input,
select {
  font-family: 'Open Sans', open-sans, sans-serif;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-right: 10px;
  margin-bottom: 15px;
  height: 51px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  line-height: 19px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 19px;
  font-weight: 300;
}

select {
  width: 70%;
}

.date {
  width: 53%;
}

.time {
  width: 33%;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 200px;
  width: 100%;
  overflow: hidden;
}

button {
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 25px;
}

button.default {
  color: #464d5d;
  background: #fff;
}

.input-group {
  display: inline-block;
  width: 100%;
}

.imput-group > input {
  width: 40%;
  margin: 0px 20px 20px 0px;
}

.pull-right {
  float: right;
  margin-right: 15px;
  margin-top: 15px;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

ul.tabsLabels {
  display: inline-block;
  padding: 0;
  margin: 0 0 -1px;
}

.modal ul.tabsLabels li {
  display: inline-block;
  margin-right: 44px;
  list-style: none;
  padding: 0;
  line-height: 14px;
}

.modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

.modal ul.tabsLabels a {
  color: #a4abb1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding: 21px 7px 22px 33px;
  border-bottom: 2px solid transparent;
  display: block;
  position: relative;
}

.modal ul.tabsLabels a.datetime {
  padding: 21px 7px 22px 0px;
}

a {
  text-decoration: none;
  -webkit-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  -o-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

a {
  background-color: transparent;
}

.modal ul.tabsLabels a.active {
  border-color: #52b266;
}

.modal ul.tabsLabels a.active,
.modal ul.tabsLabels a:hover {
  color: #464d5d;
  text-decoration: none;
}

/*@media not all, not all, (-webkit-min-device-pixel-ratio: 1.5), not all, (min-resolution: 1.5dppx)*/
.tabsLabels .datetime {
}

.tabsLabels .email {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -1100px -1110px;
}

.tabsLabels .alert {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -546px -1110px;
}

p {
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: #7e8890;
  margin: 25px 0px 25px 0px;
}

.systems {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
}

.item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  border-radius: 4px;
  background: #fff;
  height: 150px;
  text-align: center;
  margin: 0 39px 43px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.item-wrapper h2 {
  color: #424956;
  font-size: 12px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 0px;
}

.systems-wrapper {
  width: 100%;
  margin: 24px 31px;
}

.img-wrapper {
  width: 100%;
  height: 111px;
}

.systems .logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.input-group > button {
  min-width: 0;
  width: 99px;
  height: 51px;
  text-transform: uppercase;
  background: #fff;
  margin-bottom: 0;
  margin-left: 0;
  border-radius: 0 3px 3px 0;
  margin-top: 0;
  font-size: 35px;
  font-weight: 200;
}

.input-group > select {
  margin-right: 0;
  border-radius: 0 3px 3px 0;
}

.database-drop-dwon {
  display: flex;
}

.select-operation {
  background-color: #ffffff;
  border: 1px solid #dee3e9;
  height: 50px;
  width: 100%;
}

.select-operation ::v-deep button {
  justify-content: space-between;
}

.select-operation ::v-deep .dropdown-menu {
  width: 100% !important;
}
.modal .database-modal {
  position: absolute;
  right: 10px;
  top: 10px;
}

.modal .database-modal .btn-close {
  margin-left: auto;
}
</style>
